<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>

					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>

					</div>
				</el-row>
			</el-form>
		</div>
		<!-- 13535124551 -->
		<div class="operator">
			<el-button type="primary" size="mini" v-has-permission-code-and="'003000100010'"  icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" size="mini" v-has-permission-code-and="'003000100030'"  icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
			<el-button type="primary" size="mini" v-has-permission-code-and="'003000100025'"  @click="batchPush()">批量推送</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
				v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="dbColumn_name" label="学生"></el-table-column>
				<el-table-column prop="tid" label="推送老师"></el-table-column>
				<el-table-column prop="thejobtype" label="推送类型"></el-table-column>
				<el-table-column prop="method" label="推送方式"></el-table-column>
				<el-table-column prop="content" label="内容"></el-table-column>
				<el-table-column prop="subtime" label="学生读取时间"></el-table-column>
				<el-table-column prop="chetime" label="老师推送时间"></el-table-column>
				<el-table-column prop="ispushed" label="是否推送">
					<template slot-scope="scope"  >
						<!-- <el-tag v-if="scope.row.shouju" type="success">{{"√"}}</el-tag>
						<el-tag v-if="!scope.row.shouju" type="danger">{{"X"}}</el-tag> -->
						<scope v-if="scope.row.ispushed" >{{"是"}} </scope> 
						 <scope v-else-if="!scope.row.ispushed" >{{"否"}} </scope>
						<!-- <el-image :src="scope.row.shouju" style="width: 80px;"></el-image> -->
					</template>
				</el-table-column>
				 <el-table-column label="操作" fixed="right" width="260px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" v-if="!scope.row.ispushed" v-has-permission-code-and="'003000100025'"  @click="toPush(scope.$index, scope.row)">推送</el-button>
							<el-button size="mini" v-if="!scope.row.ispushed" v-has-permission-code-and="'003000100020'"   @click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" v-if="!scope.row.ispushed" v-has-permission-code-and="'003000100030'"   type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column> 
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<add ref="add"></add>
	</div>
</template>
<script>
import edit from './edit.vue';
import add from './add.vue';
import api from '@/api/xueli/tuisong.js';
 
export default {
	name: 'tuisong',
	components: {
		edit,add
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			ispush: true,
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		//去添加
		toSave() {
			this.$refs.add.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
 
			this.$refs.edit.open(row, '编辑');
		},
		//去推送
		toPush(index, row) {
			this.$utils.confirm.warning('提示', '确定推送给'+row.dbColumn_name+'？', () => {
				console.log(row.method);
				let parameter = {
				id: row.id,
			}
			console.log('row',row);
				api.toPush(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
		});
			// 	let parameter = {
			// 	ids: row.id
			// }
			// this.$utils.confirm.warning('提示','确定推送给'+row.dbColumn_name+'？', () => {
			// 	api.toPush(
			// 		parameter,
			// 		response => {
			// 			this.$utils.msg.success(response.msg);
			// 			this.list();
			// 		},
			// 		response => {
			// 			this.$utils.msg.warning(response.msg);
			// 		}
			// 	);
			// });
				
			// })
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量推送
		batchPush() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			if(!this.ispush){
				this.$utils.msg.warning("含有已推送的信息，不可推送");
				return;
			}
			let parameter = {
				ids: this.selectedto
			};
			this.$utils.confirm.warning('提示', '确定推送吗？', () => {
				api.toPush({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
				if(item.ispushed){
					//代表有推送过的信息
					this.ispush = false;
					this.$utils.msg.warning("不可选择已推送的信息，");
					return;
				}
			}
			this.ispush = true;
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

